import { NgClass, NgIf, DatePipe, NgFor } from '@angular/common';
import { ChangeDetectorRef , Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';

import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import {  ProductService } from '../../pages/service/product.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import {  CustomerService,} from '../../pages/service/customer.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { Router } from '@angular/router';
import { SocieteServiceService } from '../../services/societe-service/societe.service';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { HttpResponse } from '@angular/common/http';

@Component({
    selector: 'app-gestion-societe',
    imports: [BreadcrumbModule, MultiSelectModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ToastModule,
        ToolbarModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule, DropdownModule,
        FileUploadModule,ToggleSwitchModule,NgIf, NgClass,DatePipe,NgFor
    ],
    templateUrl: './gestion-societe.component.html',
    styleUrl: './gestion-societe.component.scss',
    providers: [ConfirmationService, MessageService, CustomerService, ProductService]
})
export class GestionSocieteComponent {
    breadcrumbSociete = {
        icon: 'pi pi-home',
        routerLink: '/rechercher-do',
        styleClass: 'breadcrumb-home'
    };
    breadcrumbItems = [{ label: 'Gestion Société' }];
    societes: any;
    DO: any;
    nomDo!: string;
    selectedSocietes: any[] | null = null;
    ajoutDialog: boolean = false;
    updateDialog: boolean = false;
    UploadDialog: boolean = false;
    detailsSocieteDialog: boolean = false;
    submitted: boolean = false;
    rowsPerPageOptions: number[] = [10]; // Valeur par défaut
    totalRecords: number = 10;
    loading: boolean = true;
    societe: any;
    AgentName!: String;
    nomAjoutInvalide: boolean = false;
    emailAjoutInvalide: boolean = false;
    nomUpdateInvalide: boolean = false;
    emailUpdateInvalide: boolean = false;
    rowGroupMetadata: any;
    uploadedFiles: any[] = [];
    selectedSocieteItem: any;
    statusOptions = [
        { label: 'Activé', value: 1 },
        { label: 'Désactivé', value: 0 }
    ];
    isDisableMode = false;
    isEnableMode = false;
  buttonDisable = false;
    add_on: any = false;


    @ViewChild('filter') filter!: ElementRef;
    @ViewChild('dt1', { static: false }) dt1!: Table;

    constructor(private societeService: SocieteServiceService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private router: Router,
        private cd: ChangeDetectorRef


    ) { }

    ngOnInit() {
        const userData = localStorage.getItem('currentUser') || '';
        let user = JSON.parse(userData);
        this.AgentName = user.name;

        let selectedDoString = sessionStorage.getItem('selectedDo');

        if (selectedDoString) {
            let selectedDo = JSON.parse(selectedDoString);
            this.DO = selectedDo.code_interne;
            this.nomDo = selectedDo.Nom;


        } else {
            this.router.navigate(['/rechercher-do']);
        }
        this.loadData();

    }

    loadData() {
        this.societeService.getAllSocieteByCodeDo(this.DO).subscribe((data: any) => {
            this.societes = data;
            this.totalRecords = data.length;
            this.updateRowsPerPageOptions();
            //console.log(this.societes)
            this.loading = false;
        });
    }

   updateRowsPerPageOptions() {
    const baseOptions = [10, 20, 30, 40, 50];

    // Limitez les options supplémentaires à des valeurs raisonnables
    const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

    if (this.totalRecords > 50) {
        const additionalOptions = [];
        // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
        const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

        for (let i = 100; i <= upperLimit; i += 100) {
            additionalOptions.push(i);
        }

        this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
    } else {
        this.rowsPerPageOptions = baseOptions;
    }

    // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
    if (this.totalRecords <= maxReasonableOption &&
        !this.rowsPerPageOptions.includes(this.totalRecords)) {
        this.rowsPerPageOptions.push(this.totalRecords);
    }
}
    openNew() {
        this.societe = {};
        this.submitted = false;
        this.ajoutDialog = true;
    }

    hideDialog() {
        this.ajoutDialog = false;
        this.updateDialog = false;
        this.nomAjoutInvalide = false;
        this.emailAjoutInvalide = false;
        this.nomUpdateInvalide = false;
        this.emailUpdateInvalide = false;
        this.detailsSocieteDialog = false

        this.submitted = false;
        this.buttonDisable = false;

    }
    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

    clear(table: Table) {
        table.clear();
        this.filter.nativeElement.value = '';
    }


    calculateCustomerTotal(name: string) {
        let total = 0;

        if (this.societes) {
            for (let annuaire of this.societes) {
                if (annuaire.service === name) {
                    total++;
                }
            }
        }

        return total;
    }
    validateAjoutForm(): boolean {
        this.nomAjoutInvalide = !this.societe.Nom || this.societe.Nom.trim() === '';
        this.emailAjoutInvalide = this.societe.AdrEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.societe.AdrEmail);
        return !(this.nomAjoutInvalide || this.emailAjoutInvalide);
    }

    validateUpdateForm(): boolean {
        this.nomUpdateInvalide = !this.societe.Nom || this.societe.Nom.trim() === '';
        this.emailUpdateInvalide = this.societe.AdrEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.societe.AdrEmail);
        return !(this.nomUpdateInvalide || this.emailUpdateInvalide);
    }

    openUploadDialog() {
        this.UploadDialog = true;
    }
    closeUploadDialog() {
        this.UploadDialog = false;
    }
    onUpload(event: any, uploader: any) {
        const files = event.files as File[];

        const validCsvFiles = files.filter((file: File) => {
            const isCsv = file.name.toLowerCase().endsWith('.csv');
            if (!isCsv) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Fichier non valide',
                    detail: `Le fichier "${file.name}" n'est pas un fichier CSV.`
                });
            }
            return isCsv;
        });

        if (validCsvFiles.length === 0) {
            uploader.clear();
            return;
        }

        let completed = 0;
        let successCount = 0;
        let errorCount = 0;

        for (let file of validCsvFiles) {
            this.societeService.importCsvSociete(this.DO ,this.add_on, file).subscribe({
                next: (event:any) => {
                    if (event instanceof HttpResponse) {
                        if (event.status === 201) {
                            successCount = successCount + 1
                            this.UploadDialog = false
                            this.loadData();
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Import terminé',
                                detail: `${successCount} fichier(s) importé(s) avec succès.`
                            });
                        } else {
                            errorCount++;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Erreur',
                                detail: `Fichier "${file.name}" : Échec d’import (code ${event.status}).`
                            });
                        }
                    }
                    checkCompletion();
                },
                error: (err:any) => {
                    errorCount++;
                    const errorMessage = err?.error?.message?.error || 'Erreur lors de l’import CSV.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: `Fichier "${file.name}" : ${errorMessage}`
                    });
                    checkCompletion();
                }
            });
        }

        const checkCompletion = () => {
            completed++;
            if (completed === validCsvFiles.length) {

                uploader.clear();
            }
        };
    }

    editSociete(societeAModifier: any) {
        this.societe = { ...societeAModifier };
        this.updateDialog = true;
    }

    ajouterSociete(societe: any) {
        if (!this.validateAjoutForm()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Champs invalides',
                detail: 'Veuillez corriger les erreurs dans le formulaire.'
            });
            setTimeout(() => {
                this.nomAjoutInvalide = false;
                this.emailAjoutInvalide = false;
            }, 3000);
            return;
        }

        societe = {
            code_DO: this.DO,
            Identifiant: this.societe.Identifiant,
            Nom: this.societe.Nom,
            Site: this.societe.Site,
            Adresse1: this.societe.Adresse1,
            Adresse2: this.societe.Adresse2,
            CodePostal: this.societe.CodePostal,
            Ville: this.societe.Ville,
            Tel1: this.societe.Tel1,
            AdrEmail: this.societe.AdrEmail,
            NumContrat: this.societe.NumContrat,
            TypeClient: this.societe.TypeClient,
            NumSerie: this.societe.NumSerie,
            TypeMachine: this.societe.TypeMachine,
            TypeContrat: this.societe.TypeContrat,
            code_Couverture: this.societe.code_Couverture,
            Zone: this.societe.Zone,
            TypeInterne: this.societe.TypeInterne,
            Info1: this.societe.Info1,
            Departement: this.societe.Departement,
            Siret: this.societe.Siret,
            AgentModif: this.AgentName
        };

      this.buttonDisable = true;

        this.societeService.addSociete(societe).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Société ajouté' });
                this.ajoutDialog = false;
                this.buttonDisable = false;

                this.loadData();
            },
            error: (err) => {
                console.error(err);
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'ajout a échoué' });
            }
        });
    }

    disableSelectedSocietes() {
        this.confirmationService.confirm({
            message: 'Confirmez la désactivation ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.confirmationService.close?.();
                if (!this.selectedSocietes || this.selectedSocietes.length === 0) {
                    console.warn('Aucune sélection');
                    return;
                }
                const codes = this.selectedSocietes.map(a => a.code_interne);
                this.societeService.disableSociete(codes).subscribe(
                    (data: any) => {

                        this.loadData();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Réussi',
                            detail: `${codes.length} société(s) désactivé(s)`,
                            life: 3000
                        });

                    });
            },
            reject: () => {
                this.confirmationService.close?.();
            }
        });




    }
    enableSelectedSocietes() {
        this.confirmationService.confirm({
            message: 'Confirmez l\'activation ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.confirmationService.close?.();
                if (!this.selectedSocietes || this.selectedSocietes.length === 0) {
                    console.warn('Aucune sélection');
                    return;
                }
                const codes = this.selectedSocietes.map(a => a.code_interne);
                this.societeService.enableSociete(codes).subscribe(
                    (data: any) => {

                        this.loadData();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Réussi',
                            detail: `${codes.length} société(s) activé(s)`,
                            life: 3000
                        });

                    });
            },
            reject: () => {
                this.confirmationService.close?.();
            }
        });




    }

    deleteByOne(societe: any) {

        this.confirmationService.confirm({
            message: 'Êtes-vous sûr de vouloir supprimer ' + societe.Nom + '?',
            header: 'Confirmer',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.confirmationService.close?.();
                this.societeService.disableSociete([societe.code_interne]).subscribe(
                    (result: any) => {

                        this.loadData();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Réussi',
                            detail: `Société ${societe.code_interne} supprimé !`,
                            life: 3000
                        });
                    },
                    (error) => {
                        console.error(error)
                    }
                )

            },
            reject: () => {
                this.confirmationService.close?.();
            }
        });
    }

    UpdateSociete(code_interne: number, societe: any) {
        if (!this.validateUpdateForm()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Validation',
                detail: 'Veuillez corriger les erreurs du formulaire'
            });
            setTimeout(() => {
                this.nomUpdateInvalide = false;
                this.emailUpdateInvalide = false;
            }, 3000);

            return;
        }


        societe = {
            Nom: this.societe.Nom,
            Identifiant:this.societe.Identifiant,
            Site: this.societe.Site,
            Adresse1: this.societe.Adresse1,
            Adresse2: this.societe.Adresse2,
            CodePostal: this.societe.CodePostal,
            Ville: this.societe.Ville,
            Tel1: this.societe.Tel1,
            AdrEmail: this.societe.AdrEmail,
            NumContrat: this.societe.NumContrat,
            TypeClient: this.societe.TypeClient,
            NumSerie: this.societe.NumSerie,
            TypeMachine: this.societe.TypeMachine,
            TypeContrat: this.societe.TypeContrat,
            code_Couverture: this.societe.code_Couverture,
            Zone: this.societe.Zone,
            TypeInterne: this.societe.TypeInterne,
            Info1: this.societe.Info1,
            Departement: this.societe.Departement,
            Siret: this.societe.Siret,
            AgentModif: this.AgentName
        };
        this.buttonDisable = true
        this.societeService.updateSociete(code_interne, societe).subscribe({
            next: () => {
                this.loadData();
                this.buttonDisable = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Société mise à jour'
                });
                this.updateDialog = false;
            },
            error: (err: any) => {
                console.error(err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'La mise à jour a échoué'
                });
            }
        });
    }

    openDetailsSociete(selectedSociete: any) {
        this.selectedSocieteItem = selectedSociete;
        this.detailsSocieteDialog = true;
    }

    onToggleChange(societe: any) {
  const originalState = societe.FlagActif;
  //console.log(`État initial de l'annuaire (${societe.code_interne}) : FlagActif = ${originalState}`);

  societe.toggleLoading = true;

  // Mise à jour visuelle immédiate
    const newState = originalState === 1 ? 0 : 1;


 const serviceCall = newState === 1
    ? this.societeService.disableSociete([societe.code_interne])
    : this.societeService.enableSociete([societe.code_interne]);



  serviceCall.subscribe({
    next: () => {


      this.messageService.add({
        severity: 'success',
        summary: 'Succès',
        detail: `Société ${newState === 1 ? 'désactivée' : 'activée'} avec succès`,
        life: 3000
      });
      this.cd.detectChanges();
    },
    error: (err:any) => {


      // Rollback



      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: `Une erreur s'est produite lors du changement d'état de l'annuaire.`,
        life: 3000
      });
    },
    complete: () => {
                societe.toggleLoading = false;
                this.cd.detectChanges();
            }
  });
}

  // Méthode pour vérifier si tous les contacts sélectionnés sont activés
    allSelectedSocietesActive(): boolean {
        if (!this.selectedSocietes || this.selectedSocietes.length === 0) {
            return false;
        }
        return this.selectedSocietes.every(societe => societe.FlagActif === 1);
    }

    // Méthode pour vérifier si tous les contacts sélectionnés sont désactivés
    allSelectedSocietesInactive(): boolean {
        if (!this.selectedSocietes || this.selectedSocietes.length === 0) {
            return false;
        }
        return this.selectedSocietes.every(societe => societe.FlagActif === 0);
    }

    // Méthode pour vérifier si la sélection est mixte (actifs et inactifs)
    hasMixedSelection(): boolean {
        if (!this.selectedSocietes || this.selectedSocietes.length === 0) return false;
        const hasActive = this.selectedSocietes.some(societe => societe.FlagActif === 1);
        const hasInactive = this.selectedSocietes.some(societe => societe.FlagActif === 0);
        return hasActive && hasInactive;
    }
    shouldDisableHeaderCheckbox(): boolean {
        if (this.isDisableMode) {
            return this.societes.every((c: any) => c.FlagActif === 0);
        } else if (this.isEnableMode) {
            return this.societes.every((c: any) => c.FlagActif === 1);
        }
        return false;
    }
     telechargerTemplateCSV() {
    this.societeService.exportTemplatesociete().subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `Template_Import_Societes.csv`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Template téléchargé' });
      },
      error: (err) => {
        console.error('Erreur lors du téléchargement :', err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Téléchargement échoué' });
      },
    });
  }

}
